import React, { memo } from "react";
import ProgressBar from "react-bootstrap/ProgressBar";

import { Handle, Position } from "reactflow";
import classNames from "classnames/bind";
import styles from "./Hub.module.scss";
let cx = classNames.bind(styles);

interface HubElProps {
  data: DataProps;
}
interface DataProps {
  risks?: number;
  controls?: number;
  inherentRisk?: number;
  residualRisk?: number;
}

export default function Hub({ data }: HubElProps) {
  return (
    <div className={styles.hub}>
      <div className="text-gray-400 fw-700">Risk Universe</div>
      <span className="text-gray-400 d-flex text-s7">
        {data.risks && data.risks + " risks "}
        {data.risks && data.controls && " | "}
        {data.controls && data.controls + " controls "}
      </span>
      <hr className={styles.hr} />

      {data.inherentRisk && (
        <div className="mb-4">
          <h6 className="text-gray-400 fw-300">Inherent Risk</h6>
          <div className="d-flex align-items-end">
            <h4 className="mv-0 fw-400 mr-2">{data.inherentRisk}%</h4>
            <ProgressBar
              className="mb-1"
              variant="success"
              now={data.inherentRisk}
            />
          </div>
        </div>
      )}

      {data.residualRisk && (
        <div className="mv-4">
          <h6 className="text-gray-400 fw-300">Residual Risk</h6>
          <div className="d-flex align-items-end">
            <h4 className="mv-0 fw-400 mr-2">{data.residualRisk}%</h4>
            <ProgressBar
              className="mb-1"
              variant="danger"
              now={data.residualRisk}
            />
          </div>
        </div>
      )}

      <Handle
        type="source"
        position={Position.Right}
        className="w-16 !bg-teal-500"
      />
    </div>
  );
}
